"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeAsisDev = exports.initializeWebDevelopmentSubApp = exports.initializeDrPicasoDevelopmentSubApp = exports.initializeCCDev = exports.initializeHybridDev = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = __importDefault(require("react-dom"));
const development_initializers_1 = require("./development.initializers");
const app_render_1 = require("../app.render");
const development_providers_1 = require("./development.providers");
const render = async (AppWithProviders) => {
    const entrypoint = async (domElement) => {
        react_dom_1.default.render((0, jsx_runtime_1.jsx)(AppWithProviders, {}), domElement);
    };
    await (0, app_render_1.appRender)({ entrypoint });
};
const initializeHybridDev = async (config, App, setFramework) => {
    const { session, authoriser, API, authenticator } = await (0, development_initializers_1.developmentHybribInitializer)(config);
    setFramework({ session, authoriser, API, authenticator });
    const AppWithProviders = () => ((0, jsx_runtime_1.jsx)(development_providers_1.DevelopmentProviders, { componentFakeLogin: config.componentFakeLogin, children: (0, jsx_runtime_1.jsx)(App, {}) }));
    render(AppWithProviders);
};
exports.initializeHybridDev = initializeHybridDev;
const initializeCCDev = async (config, App, setFramework) => {
    const { session, authoriser, API, authenticator, usd } = await (0, development_initializers_1.developmentCCInitializer)(config);
    setFramework({ session, authoriser, API, authenticator, usd });
    const AppWithProviders = () => ((0, jsx_runtime_1.jsx)(development_providers_1.DevelopmentProviders, { componentFakeLogin: config.componentFakeLogin, children: (0, jsx_runtime_1.jsx)(App, {}) }));
    render(AppWithProviders);
};
exports.initializeCCDev = initializeCCDev;
const initializeDrPicasoDevelopmentSubApp = async (config, App, setFramework) => {
    const { session, authoriser, API, authenticator } = await (0, development_initializers_1.developmentDRPicasoInitializer)(config);
    setFramework({ session, authoriser, API, authenticator });
    const AppWithProviders = () => ((0, jsx_runtime_1.jsx)(development_providers_1.DevelopmentProviders, { componentFakeLogin: config.componentFakeLogin, drAgentLoginComponent: config.drAgentLoginComponent, children: (0, jsx_runtime_1.jsx)(App, {}) }));
    render(AppWithProviders);
};
exports.initializeDrPicasoDevelopmentSubApp = initializeDrPicasoDevelopmentSubApp;
const initializeWebDevelopmentSubApp = async (config, App, setFramework) => {
    const { session, authoriser, API, authenticator } = await (0, development_initializers_1.developmentInitializer)(config);
    setFramework({ session, authoriser, API, authenticator });
    const AppWithProviders = () => ((0, jsx_runtime_1.jsx)(development_providers_1.DevelopmentProviders, { componentFakeLogin: config.componentFakeLogin, children: (0, jsx_runtime_1.jsx)(App, {}) }));
    render(AppWithProviders);
};
exports.initializeWebDevelopmentSubApp = initializeWebDevelopmentSubApp;
const initializeAsisDev = async (config, App, setFramework) => {
    const { session, authoriser, API, authenticator } = await (0, development_initializers_1.developmentAsisInitializer)(config);
    setFramework({ session, authoriser, API, authenticator });
    const AppWithProviders = () => ((0, jsx_runtime_1.jsx)(development_providers_1.DevelopmentProviders, { children: (0, jsx_runtime_1.jsx)(App, {}) }));
    render(AppWithProviders);
};
exports.initializeAsisDev = initializeAsisDev;
//# sourceMappingURL=development.renderizers.js.map